<div [ngClass]="classes" [ngStyle]="styles">
    <ng-content></ng-content>
</div>
